import { useMutation, gql } from '@apollo/client'

const useSendWspAlertForCheckInBulk = (onSuccess = () => {}, onError = () => {}) => {
  return useMutation(
    gql`
      mutation (
        $events: [CheckInBulkEventInput!]!
        $includeStudents: Boolean
        $includeParents: Boolean
      ) {
        sendWspAlertForCheckInBulk(
          events: $events
          includeStudents: $includeStudents
          includeParents: $includeParents
        ) {
          total
          sent
          failed
          results {
            eventKey
            status
            errorCode
            errorMessage
          }
        }
      }
    `,
    {
      onCompleted: onSuccess,
      onError
    }
  )
}

export default useSendWspAlertForCheckInBulk
